<h1 mat-dialog-title class="title-confirm">{{data.header}}</h1>
<mat-dialog-content>{{data.content}}</mat-dialog-content>
<mat-dialog-actions style="justify-content: end;" *ngIf="!data.isOk">
  <button mat-stroked-button cdkFocusInitial (click)="onConfirm(false)">No</button>
  <button mat-stroked-button cdkFocusInitial class="yes" (click)="onConfirm(true)">Yes</button>
</mat-dialog-actions>
<mat-dialog-actions style="justify-content: end;" *ngIf="data.isOk">
  <button mat-stroked-button cdkFocusInitial class="yes" (click)="onConfirm(true)">Ok</button>
</mat-dialog-actions>
